import React from "react";
import mainRouter from "./routes/routes";

import { RouterProvider } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { AnimatePresence } from "framer-motion";


function App() {
  return (
    <AnimatePresence mode="wait">
      <AppProvider>
        <RouterProvider router={ mainRouter } />
      </AppProvider>
    </AnimatePresence>
  );
}

export default App;
